<template>
  <div>
    <mu-paper class="insetGraph">
      <mu-tabs v-model="selectedTab">
        <mu-tab value="sleepDiary" @click.native="goTo('SleepProgress')">
          Sleep diary
        </mu-tab>
        <mu-tab value="deviceHistory">
          Device history
        </mu-tab>
      </mu-tabs>
    </mu-paper>


    <mu-row gutter v-if="$store.state.user.scope && integrationsLoaded" class="content">
      <mu-col desktop="60" tablet="60" width="100">

        <mu-row style="align-items: center;padding-top: 8px; padding-bottom: 8px;">
          <mu-col width="25" desktop="25" tablet="25">
            <mu-icon-button icon="chevron_left" @click.native="subtractDay"></mu-icon-button>
          </mu-col>
          <mu-col width="50" desktop="50" tablet="50" align="center">
            {{humanizeDate}}
          </mu-col>
          <mu-col width="25" desktop="25" tablet="25" align="right">
            <mu-icon-button icon="chevron_right" @click.native="addDay" :disabled="isSameDay"></mu-icon-button>
          </mu-col>
        </mu-row>

        <fitbit-sleep-graph
          v-if="!isLoading && integration === 'FITBIT'"
          :fitbitData="fitbitData"
        ></fitbit-sleep-graph>

        <striiv-sleep-graph
          v-if="!isLoading && integration === 'STRIIV'"
          :striivData="striivData"
        >        </striiv-sleep-graph>

        <mu-card v-if="isLoading" align="center">
          <mu-card-text >
            <mu-circular-progress></mu-circular-progress>
          </mu-card-text>
        </mu-card>


      </mu-col>
      <mu-col desktop="40" tablet="40" width="100">
        <mu-select-field style="margin-top: 8px;" icon="filter_list" v-model="integration" fullWidth>
          <mu-menu-item
            v-for="item, index in integrations"
            :key="'integrations-' +  index"
            :title="formatIntegrationLabel(item)"
            :value="item.service"></mu-menu-item>
        </mu-select-field>

        <mu-card v-if="isLoading" align="center">
          <mu-card-text>
            <mu-circular-progress></mu-circular-progress>
          </mu-card-text>
        </mu-card>
        <fitbit-sleep-stages
          v-if="!isLoading && integration === 'FITBIT'"
          :fitbitData="fitbitData"
          :date="humanizeDate"
        ></fitbit-sleep-stages>
        <striiv-sleep-stages
          v-if="!isLoading && integration === 'STRIIV'"
          :striivData="striivData"
          :date="humanizeDate"
        ></striiv-sleep-stages>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>




  import FitbitSleepGraph from "../../components/Tracking/Graphs/Sleep/FitbitSteppedChart";
  import FitbitSleepStages from "../../components/Tracking/Graphs/Sleep/FitbitSleepStages";

  import SleepApi from '../../api/Tracking/Sleep'
  import IntegrationApi from '../../api/Integrations'
  import StriivSleepGraph from "../../components/Tracking/Graphs/Sleep/StriivSleepGraph";
  import StriivSleepStages from "../../components/Tracking/Graphs/Sleep/StriivSleepStages";

  export default {
    components: {
      StriivSleepStages,
      StriivSleepGraph,
      FitbitSleepStages,
      FitbitSleepGraph
    },
    data() {
      return {
        integrationsLoaded: false,
        isLoading: true,
        fitbitData: {},
        striivData: {},
        btnColor: '#183A43',
        selectedTab: 'deviceHistory',
        integration: '',
        integrations: [],
        date: moment()
      }
    },
    watch: {
      'date': function () {
        let self = this;
        self.isLoading = true;
        let formatDate = self.date.format('YYYY-MM-DD');
        if(self.integration === 'FITBIT') {
          SleepApi.getFitBitData(self.date.format('YYYY-MM-DD'))
            .then(function (response) {
              self.fitbitData  = response.data;
              self.isLoading = false;
            })
        }
        if(self.integration === 'STRIIV') {
          self.loadStriivData(formatDate);
        }
      },
      'integration': function() {
        let self = this;
        self.isLoading = true;
        let formatDate = self.date.format('YYYY-MM-DD');
        if(self.integration === 'FITBIT') {
          SleepApi.getFitBitData(self.date.format('YYYY-MM-DD'))
            .then(function (response) {
              self.fitbitData  = response.data;
              self.isLoading = false;
            })
        }
        if(self.integration === 'STRIIV') {
          self.loadStriivData(formatDate);
        }
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/device-history');
      IntegrationApi.available.sleep()
        .then(function (response) {
          self.integrations = response.data;
          self.integration = response.data[0].service;
          let formatDate = self.date.format('YYYY-MM-DD');

          if (self.integration === 'FITBIT') {
            SleepApi.getFitBitData(self.date.format('YYYY-MM-DD'))
              .then(function (response) {
                self.fitbitData = response.data;
                self.isLoading = false;
              })
          }

          if(self.integration === 'STRIIV') {
            self.loadStriivData(formatDate);
          }

          self.integrationsLoaded = true;
        });
    },
    computed: {
      isSameDay() {
        let self = this;
        return moment().isSame(this.date, 'day')
      },
      humanizeDate() {
        if (moment().isSame(this.date, 'day')) {
          return 'Today';
        }
        return this.date.format('dddd, MMMM Do YYYY')
      }
    },
    methods: {
      loadStriivData(date) {
        let self = this;
        SleepApi.getStriivData(date).then(response => {
          self.striivData = response.data;
          self.isLoading = false;
        });
      },
      formatIntegrationLabel(item) {
        if (item.service === 'FITBIT') {
          if (_.has(item.device, 'deviceVersion')) {
            return 'Fitbit ' + item.device.deviceVersion
          }
          return 'Fitbit';
        } else {
            return _.startCase(item.service.toLowerCase());
        }
      },
      addDay() {
        let self = this;
        self.date = moment(self.date).add(1, 'day');
      },
      subtractDay() {
        let self = this;
        self.date = moment(self.date).subtract(1, 'day');
      },

      goTo(name) {
        this.$router.push({
          name: name
        })
      }
    }

  }
</script>




// WEBPACK FOOTER //
// SleepDeviceHistory.vue?21ee8372